import { getCSSVariableValue } from '@cdab/utils'
import type { PropsWithChildren } from 'react'
import { useMemo } from 'react'
import type { DefaultTheme } from 'styled-components'
import { ThemeProvider as StyledThemeProvider } from 'styled-components'

// eslint-disable-next-line @typescript-eslint/ban-types
export function ThemeProvider(props: PropsWithChildren<{}>) {
  const defaultTheme = useMemo((): DefaultTheme => {
    const sm = getCSSVariableValue('--tds-grid-sm')
    const md = getCSSVariableValue('--tds-grid-md')
    const lg = getCSSVariableValue('--tds-grid-lg')
    const xlg = getCSSVariableValue('--tds-grid-xlg')
    const xxlg = getCSSVariableValue('--tds-grid-xxlg')
    const max = getCSSVariableValue('--tds-grid-max')

    return {
      size: {
        sm: sm || '',
        md: md || '',
        lg: lg || '',
        xlg: xlg || '',
        xxlg: xxlg || '',
        max: max || ''
      }
    }
  }, [])

  return (
    <StyledThemeProvider theme={defaultTheme}>
      {props.children}
    </StyledThemeProvider>
  )
}

export default ThemeProvider
